import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

/**
 * FASE 7.4 STEP E — Forbidden (403) page.
 * Rendered when a route/action is denied by RBAC. Intentionally minimal:
 * no permission names, no role matrix, no stack traces (spec §3).
 */
export default function Forbidden() {
  return (
    <div
      data-testid="forbidden-page"
      className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6"
    >
      <div className="w-16 h-16 rounded-full border border-neutral-300 flex items-center justify-center mb-6">
        <ShieldAlert size={28} strokeWidth={1.5} className="text-neutral-500" />
      </div>
      <h1 className="text-2xl md:text-3xl font-medium text-neutral-900 mb-3">
        Accesso non autorizzato
      </h1>
      <p className="text-sm md:text-base text-neutral-600 max-w-md mb-6">
        Non hai i permessi necessari per accedere a questa sezione.
      </p>
      <Link
        to="/"
        data-testid="forbidden-cta-dashboard"
        className="inline-flex items-center gap-2 py-2 px-4 rounded-md border border-neutral-900 hover:bg-neutral-900 hover:text-[#FDFBF7] transition-colors text-sm"
      >
        Torna alla Dashboard
      </Link>
    </div>
  );
}
